import gql from 'graphql-tag'

/**
 * Query to fetch paginated vehicle lists for a given workspace.
 * Uses server-side pagination via limit/offset.
 */
export const GET_VEHICLE_LISTS_Q = gql`
  query GetVehicleLists($workspaceId: String!, $limit: Int, $offset: Int, $type: VehicleListTypeEnum) {
    vehicleLists(
      queryVehicleListsInput: {
        workspaceId: $workspaceId
        limit: $limit
        offset: $offset
        type: $type
      }
    ) {
      items {
        id
        workspaceId
        cameraId
        name
        type
        createdAt
        updatedAt
      }
      pagination {
        offset
        limit
        totalCount
      }
    }
  }
`

/**
 * Query to fetch a single vehicle list by its ID.
 * Used to display the vehicle list name in the records page title.
 */
export const GET_VEHICLE_LIST_Q = gql`
  query GetVehicleList($id: Int!) {
    vehicleList(id: $id) {
      id
      workspaceId
      cameraId
      name
      type
      createdAt
      updatedAt
    }
  }
`

